// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(query) {
  return {
    query: query
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_sharingContactsV5_sharingContacts(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "SharingContactClientContactV5",
    "SharingContactFreshContactV5"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"sharingContactsV5_sharingContacts_SharingContactFreshContactV5_email":{"b":""},"sharingContactsV5_sharingContacts_SharingContactClientContactV5_email":{"b":""},"sharingContactsV5_sharingContacts":{"u":"response_sharingContactsV5_sharingContacts"}}};

let wrapResponseConverterMap = {
  response_sharingContactsV5_sharingContacts: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"sharingContactsV5_sharingContacts_SharingContactFreshContactV5_email":{"b":""},"sharingContactsV5_sharingContacts_SharingContactClientContactV5_email":{"b":""},"sharingContactsV5_sharingContacts":{"u":"response_sharingContactsV5_sharingContacts"}}};

let responseConverterMap = {
  response_sharingContactsV5_sharingContacts: unwrap_response_sharingContactsV5_sharingContacts
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "query",
        "variableName": "query"
      }
    ],
    "concreteType": "SharingContactResult",
    "kind": "LinkedField",
    "name": "sharingContactsV5",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharingContacts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              }
            ],
            "type": "SharingContactClientContactV5",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "type": "SharingContactFreshContactV5",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SharingContactsInputRelayQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SharingContactsInputRelayQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b85561ad3eee09ff0596298391f3b2da",
    "id": null,
    "metadata": {},
    "name": "SharingContactsInputRelayQuery",
    "operationKind": "query",
    "text": "query SharingContactsInputRelayQuery(\n  $query: String\n) {\n  sharingContactsV5(query: $query) {\n    sharingContacts {\n      __typename\n      ... on SharingContactClientContactV5 {\n        databaseId\n        email\n        firstName\n        lastName\n      }\n      ... on SharingContactFreshContactV5 {\n        databaseId\n        email\n      }\n    }\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_sharingContactsV5_sharingContacts = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_sharingContactsV5_sharingContacts = unwrap_response_sharingContactsV5_sharingContacts;
exports.wrap_response_sharingContactsV5_sharingContacts = wrap_response_sharingContactsV5_sharingContacts;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
